
export const writeLog = async(message: any, filename?: string) => {
    console.log('writeLog', message);
    const runtimeConfig = useRuntimeConfig();

    const formatDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `[${year}-${month}-${day} ${hours}:${minutes}:${seconds}]`;
    }

    try {
        const response = await $fetch(`${runtimeConfig.public.API_URL}log`, {
            method: 'POST',
            body: {
                filename: filename ?? 'debug',
                message: message
            }
        })
    } catch (err: any) {
        console.log('err.response', err);
    }
}